import { FeedController, ModelUpdateEvent, Matchday, DataReceiveEvent } from "@gaming/srvg-classes-core";

export class MatchIdsFeedController extends FeedController {
    constructor( options) {
        options = options || {};
        super( options );

        this.name = 'matchidsfeedController';
    }

    handleModelUpdateEvent( event:ModelUpdateEvent, provider ) {
        if( event.propertyName === 'selectedMatchday' ) {
            var matchday = <Matchday>event.propertyValue;
            if( ! matchday || ! matchday.getSeason() ) {
                return;
            }
            var parameters = {
                season_id: matchday.getSeason().id,
                matchday_nr: matchday.nr
            };
            var result = this.cache.get( parameters );
            if( ! result ) {
                this.poll( parameters, null );
            }
            else {
                this.triggerEvent( new DataReceiveEvent( result, parameters ) );
            }
        }
    }
}